var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 62,
    viewBox: "0 0 49 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_590_6963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5352 12.253C14.7454 10.0775 6.78088 16.4664 6.78088 26.495C6.78088 36.5236 14.7454 46.4523 24.5352 48.6278C34.3249 50.8033 42.2895 44.4144 42.2895 34.3858C42.2895 24.3572 34.3249 14.4285 24.5352 12.253ZM24.5352 46.5919C15.8413 44.6599 8.7683 35.8426 8.7683 26.9366C8.7683 18.0307 15.8413 12.3569 24.5352 14.2889C33.2291 16.2209 40.302 25.0382 40.302 33.9441C40.302 42.8501 33.2291 48.5239 24.5352 46.5919Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5991 13.189C13.8094 11.0135 5.84485 17.4025 5.84485 27.431C5.84485 37.4596 13.8094 47.3883 23.5991 49.5638C33.3889 51.7393 41.3534 45.3504 41.3534 35.3218C41.3534 25.2933 33.3889 15.3646 23.5991 13.189ZM23.5991 47.5279C14.9052 45.5959 7.83227 36.7787 7.83227 27.8727C7.83227 18.9667 14.9052 13.293 23.5991 15.225C32.293 17.1569 39.366 25.9742 39.366 34.8802C39.366 43.7862 32.293 49.4599 23.5991 47.5279Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5991 47.5279C14.9052 45.5959 7.83227 36.7787 7.83227 27.8727C7.83227 18.9667 14.9052 13.293 23.5991 15.225C32.293 17.1569 39.366 25.9742 39.366 34.8802C39.366 43.7862 32.293 49.4599 23.5991 47.5279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2684 19.1503L26.5657 17.2032C25.5075 16.8043 24.7748 16.6591 24.522 16.5933L24.5296 17.7722L24.5351 18.6321C24.8618 18.7047 25.1893 18.7916 25.5148 18.8921C25.7677 18.9701 26.0194 19.0563 26.2684 19.1503Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3324 20.0863L25.5148 18.8921L25.6297 18.1392C25.2081 17.9803 24.8381 17.8616 24.5296 17.7722C24.0638 17.6372 23.7381 17.5688 23.586 17.5293L23.5991 19.5681C24.1797 19.6971 24.7629 19.8715 25.3324 20.0863Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2684 19.1503C26.0194 19.0563 25.7677 18.9701 25.5148 18.8921L25.3324 20.0863L26.2684 19.1503Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5296 17.7722L24.522 16.5933L23.586 17.5293C23.7381 17.5688 24.0638 17.6372 24.5296 17.7722Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5856 17.4837L16.8358 17.8907L17.7569 19.3888C17.8652 19.3319 17.9752 19.2772 18.0865 19.2247C18.4589 19.0491 18.8469 18.8984 19.2442 18.7754L18.3284 16.7651C17.7235 16.9522 17.1372 17.1942 16.5856 17.4837Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6496 18.4197L16.8208 20.3247C17.2917 20.0776 17.7922 19.8712 18.3082 19.7114L18.0865 19.2247L17.3924 17.7011C17.2049 17.7591 17.0192 17.8224 16.8358 17.8907C16.4274 18.0428 16.0302 18.22 15.6496 18.4197Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2442 18.7754C18.8469 18.8984 18.4589 19.0491 18.0865 19.2247L18.3082 19.7114L19.2442 18.7754Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8358 17.8907L16.5856 17.4837L15.6496 18.4197C16.0302 18.22 16.4274 18.0428 16.8358 17.8907Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7899 41.7258L22.6062 42.9197L22.4905 43.6718C22.9262 43.8367 23.3086 43.959 23.6255 44.0505C24.0924 44.1851 24.4173 44.2528 24.5615 44.2903V42.2544C24.5274 42.2455 23.7432 42.0863 22.7899 41.7258Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8539 42.6618L21.5545 44.6079C22.6318 45.0154 23.3833 45.1633 23.6255 45.2263V44.0505V43.1904C23.601 43.184 23.1895 43.1001 22.6062 42.9197C22.3776 42.8489 22.1225 42.7634 21.8539 42.6618Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5615 44.2903C24.4173 44.2528 24.0924 44.1851 23.6255 44.0505V45.2263L24.5615 44.2903Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6062 42.9197L22.7899 41.7258L21.8539 42.6618C22.1225 42.7634 22.3776 42.8489 22.6062 42.9197Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8369 42.1019L30.0584 42.5871L30.7545 44.1119C30.9417 44.0536 31.1272 43.9902 31.3105 43.9216C31.7185 43.7691 32.1156 43.5915 32.4962 43.391L31.3233 41.4868C30.8524 41.7348 30.3523 41.9418 29.8369 42.1019Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9009 43.0379L29.8185 45.0479C30.4225 44.86 31.0085 44.6175 31.5602 44.327L31.3105 43.9216L30.3873 42.4228C30.2791 42.4797 30.1695 42.5345 30.0584 42.5871C29.6859 42.7634 29.298 42.9146 28.9009 43.0379Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4962 43.391C32.1156 43.5915 31.7185 43.7691 31.3105 43.9216L31.5602 44.327L32.4962 43.391Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0584 42.5871L29.8369 42.1019L28.9009 43.0379C29.298 42.9146 29.6859 42.7634 30.0584 42.5871Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2946 22.3831C31.7657 22.8383 32.2148 23.3287 32.6295 23.8405L33.0052 23.5343L34.0261 22.7024C33.5404 22.103 33.0144 21.5287 32.4626 20.9954L31.6081 22.0106L31.2946 22.3831Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3586 23.3191C30.8297 23.7742 31.2788 24.2647 31.6935 24.7765L33.0902 23.6384C33.062 23.6036 33.0337 23.5689 33.0052 23.5343C32.5675 23.0019 32.0984 22.4903 31.6081 22.0106C31.581 21.9841 31.5538 21.9577 31.5266 21.9314L30.3586 23.3191Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0261 22.7024L33.0052 23.5343C33.0337 23.5689 33.062 23.6036 33.0902 23.6384L34.0261 22.7024Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6081 22.0106L32.4626 20.9954L31.5266 21.9314C31.5538 21.9577 31.581 21.9841 31.6081 22.0106Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9093 31.0432L36.7468 31.0881L37.8703 31.1484C37.7594 30.433 37.5954 29.7094 37.3831 28.9976L35.4943 29.2111C35.5739 29.4783 35.6456 29.7474 35.7089 30.017C35.7893 30.3593 35.8563 30.7023 35.9093 31.0432Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9733 31.9792L36.9343 32.0844C36.883 31.7534 36.8203 31.4207 36.7468 31.0881C36.6613 30.7019 36.5612 30.316 36.4471 29.9336L35.7089 30.017L34.5583 30.1471C34.739 30.7535 34.8787 31.3698 34.9733 31.9792Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8703 31.1484L36.7468 31.0881C36.8203 31.4207 36.883 31.7534 36.9343 32.0844L37.8703 31.1484Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7089 30.017C35.6456 29.7474 35.5739 29.4783 35.4943 29.2111L34.5583 30.1471L35.7089 30.017Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.841 38.0173L36.2507 39.0569L36.6164 39.3267C36.9237 38.7692 37.1861 38.1727 37.3964 37.5542L35.5056 36.5068C35.3671 36.9143 35.2021 37.3104 35.0133 37.6887C34.9579 37.7998 34.9004 37.9094 34.841 38.0173Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.905 38.9533L35.6804 40.2627C35.8927 39.8776 36.0836 39.4737 36.2507 39.0569C36.3254 38.8705 36.3954 38.6814 36.4604 38.4902L35.0133 37.6887L34.5696 37.4429C34.3904 37.97 34.1668 38.4781 33.905 38.9533Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6164 39.3267L36.2507 39.0569C36.0836 39.4737 35.8927 39.8776 35.6804 40.2627L36.6164 39.3267Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0133 37.6887C35.2021 37.3104 35.3671 36.9143 35.5056 36.5068L34.5696 37.4429L35.0133 37.6887Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1977 29.7175C11.2488 30.0489 11.3112 30.3821 11.3846 30.7151C11.4696 31.1008 11.5692 31.4862 11.6828 31.8684L12.422 31.7858L13.5723 31.6572C13.392 31.0506 13.253 30.4343 13.1592 29.8251L11.1977 29.7175Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2617 30.6535C10.372 31.3686 10.5351 32.0922 10.7468 32.8044L12.6363 32.5932C12.5567 32.3255 12.4852 32.0558 12.422 31.7858C12.3421 31.444 12.2756 31.1014 12.2232 30.7611L11.3846 30.7151L10.2617 30.6535Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5723 31.6572L12.422 31.7858C12.4852 32.0558 12.5567 32.3255 12.6363 32.5932L13.5723 31.6572Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3846 30.7151C11.3112 30.3821 11.2488 30.0489 11.1977 29.7175L10.2617 30.6535L11.3846 30.7151Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0341 38.1658C15.0626 38.2011 15.0913 38.2362 15.1201 38.2713C15.5573 38.8039 16.0261 39.3159 16.5162 39.796C16.5428 39.8221 16.5696 39.8481 16.5964 39.8741L17.7661 38.488C17.2952 38.0323 16.8464 37.5415 16.4322 37.0295L15.0341 38.1658Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0981 39.1018C14.5832 39.7015 15.1088 40.2762 15.6604 40.8101L16.5162 39.796L16.8301 39.424C16.3592 38.9683 15.9104 38.4775 15.4962 37.9655L15.1201 38.2713L14.0981 39.1018Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5964 39.8741C16.5696 39.8481 16.5428 39.8221 16.5162 39.796L15.6604 40.8101L16.5964 39.8741Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0981 39.1018L15.1201 38.2713C15.0913 38.2362 15.0626 38.2011 15.0341 38.1658L14.0981 39.1018Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6782 23.3135L13.1263 24.1175L13.5684 24.3629C13.7481 23.8362 13.9724 23.3285 14.2349 22.8535L12.4602 21.5425C12.2474 21.9275 12.056 22.331 11.8885 22.7476C11.8136 22.9338 11.7434 23.1226 11.6782 23.3135Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7422 24.2495L12.6324 25.2989C12.7713 24.8916 12.937 24.4957 13.1263 24.1175C13.1818 24.0066 13.2394 23.8972 13.2989 23.7895L11.8885 22.7476L11.5242 22.4785C11.2163 23.0356 10.9532 23.6316 10.7422 24.2495Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8885 22.7476C12.056 22.331 12.2474 21.9275 12.4602 21.5425L11.5242 22.4785L11.8885 22.7476Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5684 24.3629L13.1263 24.1175C12.937 24.4957 12.7713 24.8916 12.6324 25.2989L13.5684 24.3629Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4249 30.5011L26.1251 29.3234V21.8584L24.1377 21.4167V22.5607V30.9176L30.4889 32.329L31.4249 32.537V30.5011Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4889 31.4371L25.1891 30.2594V22.7944L24.1377 22.5607L23.2017 22.3527V31.8536L30.4889 33.473V32.329V31.4371Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4249 32.537L30.4889 32.329V33.473L31.4249 32.537Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1377 22.5607V21.4167L23.2017 22.3527L24.1377 22.5607Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2742 10.6783C33.6473 10.2454 33 9.83346 32.3502 9.45386L31.8936 10.676L31.688 11.2263C32.161 11.5027 32.6326 11.7978 33.0945 12.1063C33.213 12.1855 33.331 12.2655 33.4481 12.3464L34.2742 10.6783Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3382 11.6142C32.8657 11.288 32.3816 10.9736 31.8936 10.676C31.7341 10.5788 31.5742 10.4833 31.4142 10.3898L30.752 12.1623C31.3464 12.5096 31.9386 12.8865 32.5121 13.2824L33.0945 12.1063L33.3382 11.6142Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4481 12.3464C33.331 12.2655 33.213 12.1855 33.0945 12.1063L32.5121 13.2824L33.4481 12.3464Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8936 10.676L32.3502 9.45386L31.4142 10.3898C31.5742 10.4833 31.7341 10.5788 31.8936 10.676Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8772 13.5771C37.3099 13.0493 36.719 12.5376 36.1211 12.0566L35.4119 13.1768L35.1388 13.6081C35.6473 14.0173 36.1504 14.4507 36.6359 14.8978C36.6732 14.932 36.7103 14.9664 36.7473 15.0009L37.8772 13.5771Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9412 14.5131C36.4457 14.0521 35.9322 13.6035 35.4119 13.1768C35.3364 13.1149 35.2608 13.0535 35.1851 12.9926L34.2028 14.5441C34.7503 14.9847 35.2915 15.4532 35.8113 15.9368L36.6359 14.8978L36.9412 14.5131Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7473 15.0009C36.7103 14.9664 36.6732 14.932 36.6359 14.8978L35.8113 15.9368L36.7473 15.0009Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4119 13.1768L36.1211 12.0566L35.1851 12.9926C35.2608 13.0535 35.3364 13.1149 35.4119 13.1768Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8601 51.1386C14.4869 51.5714 15.1343 51.9833 15.7841 52.363L16.2407 51.1408L16.4463 50.5905C15.9733 50.3141 15.5017 50.019 15.0398 49.7105C14.9212 49.6313 14.8033 49.5513 14.6862 49.4704L13.8601 51.1386Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7201 51.427C16.56 51.3335 16.4002 51.238 16.2407 51.1408L15.7841 52.363L16.7201 51.427Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2407 51.1408C15.7527 50.8432 15.2686 50.5288 14.7961 50.2026L15.0398 49.7105C15.5017 50.019 15.9733 50.3141 16.4463 50.5905L16.2407 51.1408Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6222 48.5344L14.6862 49.4704C14.8033 49.5513 14.9212 49.6313 15.0398 49.7105L15.6222 48.5344Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7201 51.427L17.3823 49.6545C16.7879 49.3072 16.1956 48.9303 15.6222 48.5344L15.0398 49.7105C15.5017 50.019 15.9733 50.3141 16.4463 50.5905L16.2407 51.1408C16.4002 51.238 16.56 51.3335 16.7201 51.427Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.193 47.3037C11.6885 47.7646 12.202 48.2133 12.7224 48.6399C12.7978 48.7018 12.8734 48.7632 12.9491 48.8241L13.9314 47.2726C13.384 46.832 12.8427 46.3635 12.3229 45.8799L11.4983 46.919L11.193 47.3037Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.257 48.2397C10.8244 48.7675 11.4153 49.2791 12.0131 49.7601L12.7224 48.6399L12.9954 48.2087C12.4869 47.7994 11.9838 47.3661 11.4983 46.919C11.4611 46.8847 11.424 46.8503 11.3869 46.8159L10.257 48.2397Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9491 48.8241C12.8734 48.7632 12.7978 48.7018 12.7224 48.6399L12.0131 49.7601L12.9491 48.8241Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4983 46.919L12.3229 45.8799L11.3869 46.8159C11.424 46.8503 11.4611 46.8847 11.4983 46.919Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.05213 37.6308C5.7198 36.9893 5.41601 36.3494 5.13994 35.712C5.13701 35.7053 5.13408 35.6985 5.13115 35.6917C-2.61558 17.7713 11.5479 1.90026 29.2593 9.96872C29.4629 10.0615 29.6669 10.1573 29.8714 10.2564L30.3645 8.39376C9.78398 -1.57889 -6.5383 18.025 4.56766 38.7163L1.87855 38.1187V39.2627V40.1546L7.10355 41.3157L8.03955 41.5237V35.2124L6.05213 34.7707V35.9147V37.6308Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.11613 38.5668C-4.67244 19.6716 10.3009 2.16187 28.9354 11.1924L29.2593 9.96872L29.4285 9.32975C8.84798 -0.642906 -7.4743 18.961 3.63166 39.6522L1.87855 39.2627L0.942552 39.0547V41.0906L7.10355 42.4597V41.3157V36.1484L6.05213 35.9147L5.13994 35.712L5.11613 35.7067V38.5668Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.87855 39.2627V38.1187L0.942552 39.0547L1.87855 39.2627Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13115 35.6917C5.13408 35.6985 5.13701 35.7053 5.13994 35.712L6.05213 35.9147V34.7707L5.13115 35.6917Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03955 41.5237L7.10355 41.3157V42.4597L8.03955 41.5237Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2593 9.96872L28.9354 11.1924L29.8714 10.2564C29.6669 10.1573 29.4629 10.0615 29.2593 9.96872Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9867 23.5268V21.4909L41.8257 20.1218V21.2658V26.4331L42.8771 26.6668L43.2581 26.7514L43.8131 26.8748V24.9104C51.9539 43.4073 37.1298 59.3137 19.1989 50.6241L18.875 51.8477L18.7058 52.4867C39.1061 62.3721 55.2218 43.2798 44.8502 22.8298L47.0507 23.3188L47.9867 23.5268Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0507 24.4628V23.3188V22.4269L41.8257 21.2658L40.8897 21.0578V27.3691L42.8771 27.8108V26.6668V25.8464C43.0102 26.1488 43.1372 26.4505 43.2581 26.7514C43.3235 26.9142 43.3871 27.0767 43.4489 27.239C50.1893 44.9198 36.079 59.6818 18.875 51.8477C18.6714 51.755 18.4673 51.6591 18.2629 51.56L17.7698 53.4227C38.1701 63.3081 54.2858 44.2158 43.9142 23.7658L47.0507 24.4628Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8257 21.2658V20.1218L40.8897 21.0578L41.8257 21.2658Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9867 23.5268L47.0507 23.3188V24.4628L47.9867 23.5268Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2581 26.7514L42.8771 26.6668V27.8108L43.4489 27.239C43.3871 27.0767 43.3235 26.9142 43.2581 26.7514Z",
    fill: "#4A0B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.875 51.8477L19.1989 50.6241L18.2629 51.56C18.4673 51.6591 18.6714 51.755 18.875 51.8477Z",
    fill: "#4A0B82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_590_6963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.9658,
    height: 49.9769,
    fill: "white",
    transform: "matrix(0.976187 0.21693 0 1 0 0.565918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard8);
export default __webpack_public_path__ + "static/media/card8.274d54903ef2328cd410fa9448e3264c.svg";
export { ForwardRef as ReactComponent };